import type { HMSChangeMultiTrackStateParams } from "@100mslive/react-sdk";
import {
  selectLocalPeer,
  selectTracksMap,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { ProviderMuteAllPeersAudio } from "../types";

export const useHMSMuteAllPeersAudio = (): ProviderMuteAllPeersAudio => {
  const hmsActions = useHMSActions();
  const localPeer = useHMSStore(selectLocalPeer);
  const tracksMap = useHMSStore(selectTracksMap);
  const areAllPeersMuted = Object.values(tracksMap)
    .filter(track => track.peerId !== localPeer?.id && track.type === "audio")
    .every(track => !track.enabled);

  const muteAllPeersMicrophone = () => {
    const options: HMSChangeMultiTrackStateParams = {
      enabled: false,
      roles: ["host"],
      type: "audio",
    };

    void hmsActions.setRemoteTracksEnabled(options);
  };

  return {
    muteAllPeersMicrophone,
    areAllPeersMuted,
  };
};
